import {
  Breadcrumbs,
  Theme,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { Link } from "react-router-dom";
import { useAppSelector } from "store/hooks";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    margin: theme.spacing(2),
  },
  title: {
    color: "#000",
  },
  LinkItem: {
    textDecoration: "none",
    color: theme.palette.grey[700],
  },
}));

const EntaBreadcrumb = () => {
  const classes = useStyles();
  const theme = useTheme();
  const isSmallDevice = useMediaQuery(theme.breakpoints.down("sm"));

  const { nodes } = useAppSelector((state) => {
    return state.common.breadcrumb;
  });

  return (
    <Breadcrumbs
      maxItems={isSmallDevice ? 0 : undefined}
      itemsAfterCollapse={1}
      itemsBeforeCollapse={0}
      aria-label="breadcrumb"
      className={classes.container}
    >
      <Typography variant="subtitle1" className={classes.title}>
        RPA Connect
      </Typography>

      {nodes.map(({ text, url }, key) => {
        if (nodes.length === key + 1 || !url) {
          return (
            <Typography key={key} color="textPrimary">
              {text}
            </Typography>
          );
        } else {
          return (
            <Link
              key={key}
              color="inherit"
              to={url ? url : ""}
              className={classes.LinkItem}
            >
              {text}
            </Link>
          );
        }
      })}
    </Breadcrumbs>
  );
};

export default EntaBreadcrumb;
